import messagesApi from '@/api/messages';

// 会话级已读游标的 debounce 合并: 同一 conversationId 在 3000ms 内的多次调用会合并为最后一次,
// 仅提交最新的 lastReadMessageId. 适用于:
//   - 用户点击进入会话时的初始 mark-read;
//   - 当前会话窗口打开期间收到 WS 新消息触发的 "自动已读".
// 模块级单例 Map 在整个 SPA 生命周期内共享, 跨组件多次调用同样会被合并.
const _readDebounceMap = new Map(); // conversationId -> { timer, lastId }
const READ_DEBOUNCE_MS = 3000;

function _flushMarkRead(conversationId) {
  const cur = _readDebounceMap.get(conversationId);
  if (!cur) return;
  _readDebounceMap.delete(conversationId);
  messagesApi.markConversationRead(conversationId, cur.lastId)
    .catch(e => console.error('markConversationRead error:', e));
}

export default {
  async getMessages(fromTime, toTime) {    
    console.log(`services.getMessages, fromTime:${fromTime}, toTime:${toTime}`);

    try {
      const response = await messagesApi.getMessages(fromTime, toTime);
      if (response && response.data) {
        if (response && response.status === 200) {
          const rsp = response.data;
          console.log('@@@@ services.getMessages, rsp:', rsp);          
          return rsp;
        }
      }
      throw new Error('getMessages, response:', response);
    } catch (error) {
      console.error('getMessages, error:', error);
      // 错误处理逻辑
      throw error;
    }
  },
  
  // 仅拉取会话元数据(无消息), 用于侧边栏"最近联系人"的轻量加载.
  async getConversations() {
    console.log(`services.getConversations`);
    try {
      const response = await messagesApi.getConversations();
      if (response && response.status === 200 && response.data) {
        console.log('@@@@ services.getConversations, len:', Array.isArray(response.data) ? response.data.length : 0);
        return response.data;
      }
      throw new Error('getConversations, response:', response);
    } catch (error) {
      console.error('getConversations, error:', error);
      throw error;
    }
  },

  // 拉取指定会话最近 limit 条消息(默认 300). 后端做参与方鉴权.
  async getMessagesByConversation(conversationId, limit) {
    console.log(`services.getMessagesByConversation, conversationId:${conversationId}, limit:${limit}`);
    try {
      const response = await messagesApi.getMessagesByConversation(conversationId, limit);
      if (response && response.status === 200 && response.data) {
        console.log('@@@@ services.getMessagesByConversation, len:', Array.isArray(response.data) ? response.data.length : 0);
        return response.data;
      }
      throw new Error('getMessagesByConversation, response:', response);
    } catch (error) {
      console.error('getMessagesByConversation, error:', error);
      throw error;
    }
  },

  async setMessagesRead(toUid) {
    console.log(`services.setMessagesRead, toUid:${toUid}`);

    try {
      const response = await messagesApi.setMessagesRead(toUid);
      if (response && response.data) {
        if (response && response.status === 200) {
          const rsp = response.data;
          console.log('@@@@ services.setMessagesRead, rsp:', rsp);
          return rsp;
        }
      }
      throw new Error('setMessagesRead, response:', response);
    } catch (error) {
      console.error('setMessagesRead, error:', error);
      // 错误处理逻辑
      throw error;
    }
  },

  // 按 merchantId 查公司名: 后端只返回 {merchantId, companyName}.
  // 用于访客侧首次打开某商户聊天 (无会话) 时把 fallback 名替换成真实名.
  // 失败 (404 / 网络) 不抛错, 返回 null, 调用方继续用 fallback.
  async getMerchantInfo(merchantId) {
    if (!merchantId) return null;
    try {
      const response = await messagesApi.getMerchantInfo(merchantId);
      if (response && response.status === 200 && response.data) return response.data;
      return null;
    } catch (e) {
      console.warn('getMerchantInfo, error:', e && e.message);
      return null;
    }
  },

  // 调度一次"会话已读"上报: 3000ms 内的多次调用按 conversationId 合并, 只发最后一次.
  // 调用方应仅在 unreadCount > 0 (或新到了对方消息) 时触发, 避免无效请求.
  scheduleMarkConversationRead(conversationId, lastReadMessageId) {
    if (!conversationId || !lastReadMessageId) return;
    const cur = _readDebounceMap.get(conversationId);
    const lastId = cur ? Math.max(cur.lastId, lastReadMessageId) : lastReadMessageId;
    if (cur && cur.timer) clearTimeout(cur.timer);
    const timer = setTimeout(() => _flushMarkRead(conversationId), READ_DEBOUNCE_MS);
    _readDebounceMap.set(conversationId, { timer, lastId });
  },
};
